import React from 'react';
import { I18nextProvider } from 'react-i18next';
import i18n from '../configs/i18next';

export default function I18nProvider({ children }) {
  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}
